<script>
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';

    export default {
        components: {
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                dataSource: httpService.getDxDataSource('battery-ownership/grid')
            };
        }
    };
</script>

<template>
    <div class="main-content-header">
        <h3>
            <i class="bi bi-card-checklist"></i>
            Battery Ownership Changes
        </h3>
    </div>
    <div class="main-content-body">
        <AdminGrid :data-source="dataSource" storage-key="battery-ownership" :show-actions="false">
            <DxColumn data-field="batteryName" caption="Battery" />
            <DxColumn data-field="userName" caption="User" />
            <DxColumn data-field="dateTime" caption="Date" data-type="date" format="MM/dd/yyyy HH:mm" />
            <DxColumn data-field="from" />
            <DxColumn data-field="to" />
        </AdminGrid>
    </div>
</template>
